import React, { Component } from "react";
import { IImage } from "src/models/Image";
import * as s from "./BackgroundImage.module.scss";
export interface BackgroundImageProps {
  image: string | IImage;
  children?: any;
  fadeIn?: boolean;
  loading?: "lazy" | "eager";
  className?: string;
  backgroundColor?: string;
  alt?: string;
  onLoad?: () => void;
  objectFit?: `fill` | `contain` | `cover` | `none` | `scale-down`;
}

export class BackgroundImage extends Component<BackgroundImageProps> {
  static defaultProps = {
    size: "mediumLarge"
  };
  render() {
    const { image, children, className } = this.props;

    const wrapperClasses = [s.wrapper];
    if (className) {
      wrapperClasses.push(className);
    }

    let url = typeof image === "string" ? image : image?.mediaItemUrl;
    return (
      <div className={wrapperClasses.join(" ")}>
        {/* {image?.localFile?.childImageSharp?.gatsbyImageData && (
          <GatsbyImage
            className={s.image}
            // fluid={image.localFile.childImageSharp.fluid}
            // fadeIn={fadeIn}
            image={image.localFile.childImageSharp.gatsbyImageData}
            loading={loading}
            objectFit={objectFit}
            backgroundColor={backgroundColor}
            onLoad={onLoad}
            objectPosition={`${horiz} ${vert}`}
            alt={alt || ""}
          />
        )} */}
        {!!url && (
          <div
            style={{ backgroundImage: `url("${url}")` }}
            className={s.backgroundImage}
          />
          // <img className={s.image} src={image.url || image.mediaItemUrl} />
        )}
        <div className={s.content}>{children}</div>
      </div>
    );
  }
}
